const mq = (maxWidth: number): string => `@media (max-width: ${maxWidth}px)`;

type Breakpoints = 'large' | 'medium' | 'small' | 'extrasmall';

export const mediaQueries: Record<Breakpoints, string> = {
  large: mq(1601),
  medium: mq(1000),
  small: mq(570),
  extrasmall: mq(400)
}